import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter"]
  static values = {
    current: { type: Number, default: 0 }
  }

  connect() {
    this.#updateCounter()
  }

  prev() {
    this.#step(-1)
  }

  next() {
    this.#step(1)
  }

  currentValueChanged() {
    this.#updateCounter()
  }

  // Always scrolls to the resulting match, even when the index is already at a
  // boundary, so a single-match thread still jumps on either arrow click.
  #step(delta) {
    const matches = this.#matchEls()
    if (matches.length === 0) return
    this.currentValue = Math.min(Math.max(this.currentValue + delta, 0), matches.length - 1)
    requestAnimationFrame(() => this.#jumpToCurrent())
  }

  // Ordered by the chronological match index rendered on each card so the
  // navigator counter and the eyebrow chip agree; DOM order is tree order.
  #matchEls() {
    return Array.from(this.element.querySelectorAll("[data-match-el]"))
      .sort((a, b) => Number(a.dataset.matchIndex) - Number(b.dataset.matchIndex))
  }

  #jumpToCurrent() {
    const el = this.#matchEls()[this.currentValue]
    if (!el) return
    el.scrollIntoView({ behavior: "smooth", block: "center" })
    // Remove-then-reflow-then-add restarts the CSS animation on repeat visits
    // to the same match (e.g. stepping there twice via prev/next).
    el.classList.remove("match-flash")
    void el.offsetWidth
    el.classList.add("match-flash")
  }

  #updateCounter() {
    if (!this.hasCounterTarget) return
    const total = this.#matchEls().length
    this.counterTarget.textContent = total > 0 ? `${this.currentValue + 1} of ${total}` : "0 of 0"
  }
}
